import { MediaFileType } from './types';

export const tabToNetworkMapping: Record<string, string> = {
  facebook: 'facebook',
  googlemybusinesslocation: 'googleBusiness',
  instagram: 'instagram',
  bluesky: 'bluesky',
  linkedin: 'linkedIn',
  threads: 'threads',
  pinterest: 'pinterest',
  tiktok: 'tikTok',
  x: 'x',
  wordpress: 'wordpress',
  youtube: 'youTube',
  other: 'other',
  group: 'groups',
};

export const tabToFriendlyNameMapping: Record<string, string> = {
  facebook: 'Facebook',
  googlemybusinesslocation: 'Google Business',
  instagram: 'Instagram',
  bluesky: 'Bluesky',
  linkedin: 'LinkedIn',
  threads: 'Threads',
  pinterest: 'Pinterest',
  tiktok: 'TikTok',
  x: 'X',
  wordpress: 'WordPress',
  youtube: 'YouTube',
  other: 'Other',
};

export const supportedFileTypes: {
  [key in MediaFileType]: string;
} = {
  [MediaFileType.Image]: 'image/',
  [MediaFileType.Video]: 'video/',
  [MediaFileType.Document]: 'application/pdf',
  [MediaFileType.Unspecified]: '',
};

export const fileSizeLimits: {
  [key in MediaFileType]: string;
} = {
  [MediaFileType.Image]: '36MB',
  [MediaFileType.Video]: '2GB',
  [MediaFileType.Document]: '100MB',
  [MediaFileType.Unspecified]: '',
};

export const mimeTypeToExtension = {
  'video/mp4': 'MP4',
  'video/quicktime': 'MOV',
  'video/x-msvideo': 'AVI',
  'video/webm': 'WEBM',
  'video/h264': 'H264',
  'video/x-m4v': 'M4V',
  'video/x-matroska': 'MKV',
  'video/mpeg': 'MPEG',
  'application/pdf': 'PDF',
  'image/bmp': 'BMP',
  'image/gif': 'GIF',
  'image/jpeg': 'JPEG',
  'image/png': 'PNG',
  'image/svg+xml': 'SVG',
  'image/tiff': 'TIFF',
  'image/webp': 'WEBP',
} as const;
